import { useEffect, useState } from 'react';

// Native app WebView detection: Android System WebView ("wv" token or legacy
// Version/x.x Chrome UA), iOS in-app webviews (no "Safari" token), React Native.
const isWebviewUA = () => {
  if (typeof window === 'undefined') return false;
  if (window.ReactNativeWebView) return true;
  const ua = navigator.userAgent || '';
  if (/\bwv\b/.test(ua)) return true;
  if (/android/i.test(ua) && /Version\/[\d.]+/.test(ua) && /chrome/i.test(ua)) return true;
  if (/iphone|ipad|ipod/i.test(ua) && !/safari/i.test(ua)) return true;
  return false;
};

// True when on a mobile-sized screen (<1024px — the app's mobile-mode breakpoint,
// same as Live Tracking/Chat) OR inside a native app WebView. Live-updates on resize.
export const useIsMobileOrWebview = () => {
  const [mobile, setMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(max-width: 1023px)').matches
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1023px)');
    const onChange = (e) => setMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return mobile || isWebviewUA();
};
